import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const featuredImages = [
    'https://readdy.ai/api/search-image?query=Premium%20white%20sneakers%20close%20up%20on%20light%20surface%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20warm%20beige%20tones&width=300&height=200&seq=dropdown-feat-1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Cozy%20knit%20sweater%20folded%20showing%20texture%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20editorial%20textile%20photography%2C%20warm%20neutral%20tones&width=300&height=200&seq=dropdown-feat-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Minimalist%20t-shirt%20flat%20lay%20on%20clean%20surface%2C%20simple%20elegant%20composition%2C%20soft%20lighting%2C%20warm%20beige%20background%2C%20editorial%20garment%20style&width=300&height=200&seq=dropdown-feat-3&orientation=landscape',
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-10">
          <div className="flex-1 lg:max-w-md">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
              Quick Category Access
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-sm">
              Select a category below to browse products on our main website. All categories link directly to curated Basetao Spreadsheet collections.
            </p>

            <div ref={dropdownRef} className="relative w-full max-w-sm">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between px-5 py-3.5 bg-white border border-background-200/70 rounded-lg text-sm font-medium text-foreground-700 hover:border-background-300/60 transition-all duration-200 cursor-pointer shadow-sm"
              >
                <span>{isOpen ? 'Select a category...' : 'Choose a category to explore'}</span>
                <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isOpen && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-background-200/70 rounded-lg shadow-lg py-2 z-40 max-h-72 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-900 transition-colors duration-150"
                      onClick={() => setIsOpen(false)}
                    >
                      <span className="w-7 h-7 rounded bg-background-100 flex items-center justify-center text-xs font-medium text-foreground-500 flex-shrink-0">
                        {cat.name.charAt(0)}
                      </span>
                      <span className="truncate">{cat.name}</span>
                      <i className="ri-arrow-right-up-line ml-auto text-foreground-300 text-xs flex-shrink-0"></i>
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="flex-1 grid grid-cols-3 gap-3">
            {featuredImages.map((img, idx) => (
              <div key={idx} className="rounded-lg overflow-hidden aspect-[3/2]">
                <img
                  src={img}
                  alt={`Featured Basetao product ${idx + 1}`}
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}